import { Tab } from "@renderbus/ui";
import { useGetTabsList } from "./hooks/useInitTabList";
import {
  NotificationStoreContainerProvider,
  useNotificationStore,
} from "./store/notification-store";
import { NotificationTabType } from "./constants";
import { PageContainer } from "@/components/page-container";
import { useTranslation } from "react-i18next";

export function NotificationView() {
  const { tabsList } = useGetTabsList();
  const { t } = useTranslation("notification");
  const { noReadNum, totalNum, setCurrentNotificationTab } =
    useNotificationStore();
  return (
    <>
      <span style={{ marginBottom: "20px", display: "block" }}>
        （
        {t("notification_message_sum", {
          total: totalNum,
          num: noReadNum.reduce((val, oldVal) => val + oldVal),
        })}
        ）
      </span>
      <PageContainer>
        <Tab
          tabsList={tabsList}
          onChange={(key) =>
            setCurrentNotificationTab(key as NotificationTabType)
          }
          items={tabsList.map((item, i) => {
            return {
              label: (
                <div>
                  {item.label}
                  {item.key !== NotificationTabType.NotificationSetting &&
                    `(${noReadNum[i]})`}
                </div>
              ),
              key: String(item.key),
              children: item.children,
            };
          })}
        />
      </PageContainer>
    </>
  );
}

export default function Notification() {
  return (
    <NotificationStoreContainerProvider>
      <NotificationView />
    </NotificationStoreContainerProvider>
  );
}
